import { render, staticRenderFns } from "./ActivitySummary.vue?vue&type=template&id=4e7c0547&scoped=true&lang=html&"
import script from "./ActivitySummary.vue?vue&type=script&lang=js&"
export * from "./ActivitySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7c0547",
  null
  
)

export default component.exports